import "./IntakePath.module.css";
import Header from "@/reusable_sections/Header";
import Journey from "./sections/Journey";
import Expectations from "./sections/Expectations";
import Intake from "./sections/Intake";
import Footer from "@/reusable_sections/Footer";
export default function IntakePathPage() {
  return <div>
      <Header />
      <Journey />
      <Expectations />
      <Intake />
      <Footer />
    </div>;
}